module.exports = __webpack_public_path__ + "assets/class-type.f2e056f2.svg";